module.exports = __webpack_public_path__ + "img/money.8b25ec11.png";